import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationSystemManagersService,
  AdminManagerModel,
  AdminManagerAddRequest,
  AdminManagerEditRequest,
  PageModelAdminManagerModel,
  AdminManagerListRequest
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationSystemManagersApiService {
  constructor(private apiService: AdministrationSystemManagersService) {}

  public addManager(body: AdminManagerAddRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminManagerModel> {
    return this.apiService.adminManagersAdd(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteManager(userId: string, suspend?: boolean, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminManagersDelete(userId, suspend, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editManager(userId: string, body: AdminManagerEditRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminManagerModel> {
    return this.apiService.adminManagersEdit(userId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getManager(userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminManagerModel> {
    return this.apiService.adminManagersGet(userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listManagers(body: AdminManagerListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelAdminManagerModel> {
    return this.apiService.adminManagersList(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
